var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7338 2.2753C13.5637 2.10488 13.3329 2.0091 13.0921 2.0091C12.8514 2.0091 12.6206 2.10488 12.4505 2.2753L8 6.71672L3.54949 2.2662C3.37945 2.09578 3.14859 2 2.90785 2C2.66711 2 2.43625 2.09578 2.26621 2.2662C1.91126 2.62115 1.91126 3.19453 2.26621 3.54948L6.71672 7.99999L2.26621 12.4505C1.91126 12.8055 1.91126 13.3788 2.26621 13.7338C2.62116 14.0887 3.19454 14.0887 3.54949 13.7338L8 9.28327L12.4505 13.7338C12.8055 14.0887 13.3788 14.0887 13.7338 13.7338C14.0887 13.3788 14.0887 12.8055 13.7338 12.4505L9.28328 7.99999L13.7338 3.54948C14.0796 3.20363 14.0796 2.62115 13.7338 2.2753Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.eddf52d8.svg";
export { ForwardRef as ReactComponent };